import { Navigate, useLocation } from 'react-router-dom';
import type { ReactNode } from 'react';
import { useRolle, type Rolle } from '../auth/useRolle';

function Ladeanzeige() {
  return (
    <div className="container" style={{ textAlign: 'center' }}>
      <p className="label">einen Moment …</p>
    </div>
  );
}

/**
 * Schützt alle inhaltlichen Routen. Ohne gültige Anmeldung → zur Startseite,
 * das Ziel wird für die Rückkehr nach dem Login gemerkt.
 *
 * WICHTIG: Das ist nur Komfort. Die echte Absicherung liegt in der Daten-API
 * (siehe technical-design.md, Abschnitt 4 / 7).
 */
export function RequireAuth({ children }: { children: ReactNode }) {
  const { laedt, angemeldet } = useRolle();
  const location = useLocation();
  if (laedt) return <Ladeanzeige />;
  if (!angemeldet) {
    const ziel = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/?weiter=${ziel}`} replace />;
  }
  return <>{children}</>;
}

/** Blendet Bereiche aus, die die aktuelle Rolle nicht darf. */
export function RequireRolle({
  mindestens,
  children,
}: {
  mindestens: Exclude<Rolle, null>;
  children: ReactNode;
}) {
  const { laedt, rolle } = useRolle();
  const rang: Record<string, number> = { Leser: 1, Tester: 2, Verwalter: 3 };
  if (laedt) return <Ladeanzeige />;
  if (!rolle || rang[rolle] < rang[mindestens]) {
    return <Navigate to="/app" replace />;
  }
  return <>{children}</>;
}
